module.exports = __webpack_public_path__ + "img/03_title.3e7bdbcc.png";